import React, { useEffect, useState } from 'react';
import cx from 'classnames';

import styles from './device.module.scss';

const devices = {
  'mobile': {
    width: 375 + 60,
    height: 667 + 60
  },
  'tablet': {
    width: 768 + 60,
    height: 1024 + 60
  },
  'tabletls': {
    width: 1024 + 60,
    height: 768 + 60
  }
}

export default function Device({mode, className, children}){
  const [zoom, setZoom] = useState(1);

  const calculateScale = () => {
    if(mode === 'none'){
      setZoom(1);
      return;
    }

    const dimension = devices[mode];
    const screenDimension = {
      width: window.innerWidth,
      height: window.innerHeight
    };

    var scale = Math.min(screenDimension.width/dimension.width, screenDimension.height/dimension.height)
    scale = Math.min(1, scale);
    setZoom(scale);
  }

  useEffect(() => {
    calculateScale();
  }, [mode]);

  const style = {
    transform: `scale(${zoom})`
  }

  return (
    <div className={cx(styles.device, className, {
      [styles.desktop]: mode === 'desktop',
      [styles.tablet]: mode === 'tablet',
      [styles.tabletls]: mode === 'tabletls',
      [styles.mobile]: mode === 'mobile'
    })} style={style}>
      <div className={styles.inner}>
        {children}
      </div>
    </div>
  )
}
